import styled from "@emotion/styled";

import type { ModalDialogProps } from "@skilitics/designer-ui-components";
import { FormattedMessage, type FormatMessages, type FormatStrings } from "@skilitics/localization";

const ContentContainer = styled.div`
  padding-block-end: 1rem;
`;

type Props = {
  node: { title?: string };
  formatStrings?: Partial<Record<keyof typeof formatStrings, FormatStrings>>;
};

export const createConfirmDeleteProps = ({
  node: { title },
  formatStrings: customFormatStrings = {},
}: Props): ModalDialogProps => {
  const { header, content, cancelLabel, confirmLabel } = { ...formatStrings, ...customFormatStrings };

  return {
    header: <FormattedMessage messages={header} values={{ title }} />,
    children: (
      <ContentContainer>
        <FormattedMessage messages={content} values={{ title }} />
      </ContentContainer>
    ),
    buttons: "confirm",
    cancelLabel: <FormattedMessage messages={cancelLabel} />,
    confirmLabel: <FormattedMessage messages={confirmLabel} values={{ title }} />,
    hideDividers: true,
  };
};

const formatStrings = {
  header: {
    en: "Delete {title}",
  },
  content: {
    en: "Are you sure you want to delete {title}? This cannot be undone.",
  },
  cancelLabel: {
    en: "Cancel",
  },
  confirmLabel: {
    en: "Yes, Delete",
  },
} satisfies FormatMessages;
